export const actions = {
  set_state: 'traffics/set_state',
  get_traffics: 'traffics/get_traffics',
  download_traffics: 'traffics/download_traffics',
  get_activity: 'traffics/get_activity'
}
